<template>
  <vame @update="update">
    <div class="note">
      <small>WASD or Arrow Keys to move.</small>
    </div>
    <keyboard-input
      :key-map="{
        curUp: [ 'w', 'arrowup' ],
        curDown: [ 's', 'arrowdown' ],
        curLeft: [ 'a', 'arrowleft' ],
        curRight: [ 'd', 'arrowright' ]
      }"
      @keypress="keypress"
    />
    <renderer
      :scale="3"
      :pixel-scale="6"
      :clear-color="'#fff'"
    >
      <sprite
        :x="Math.floor(x)"
        :y="Math.floor(y)"
        :width="16"
        :height="16"
        src="logo.png"
      />
    </renderer>
  </vame>
</template>

<script>
import { components } from '@/vame.js'

export default {
  components: {
    ...components
  },

  data () {
    return {
      toX: 16,
      toY: 16,
      x: 16,
      y: 16
    }
  },

  methods: {
    update (delta) {
      const dx = (this.toX - this.x) * delta * 0.2
      this.x = this.x + dx

      const dy = (this.toY - this.y) * delta * 0.2
      this.y = this.y + dy
    },

    keypress (button) {
      if (button === 'curRight') {
        if (this.toX < 320-16) this.toX += 16
      }
      else if (button === 'curLeft') {
        if (this.toX > 0) this.toX -= 16
      }
      else if (button === 'curUp') {
        if (this.toY > 0) this.toY -= 16
      }
      else if (button === 'curDown') {
        if (this.toY < 176-16) this.toY += 16
      }
    }
  }
}
</script>

<style lang="sass">
body
  background: #fafafa
</style>
